module.exports = __webpack_public_path__ + "media/components/app-store/static/s3-5715a2e2efcc19d1f5db013ae46d2826.jpg";